import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, [
      _createElementVNode("path", { d: "M18.25 12.5a5.75 5.75 0 1 0-5.15-3.19.94.94 0 0 1 .077.66l-.343 1.28a.747.747 0 0 0 .916.916l1.28-.343a.94.94 0 0 1 .66.077c.77.384 1.64.6 2.56.6Z" }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "M1.008 10.123c-.084 2.194.472 5.921 4.21 9.66A16.3 16.3 0 0 0 7.9 21.967M2.768 6.678c1.602-1.602 4.158-1.387 5.175.436L8.69 8.45c.673 1.207.403 2.79-.658 3.851q0 0 0 0s-1.287 1.287 1.046 3.62c2.332 2.332 3.62 1.047 3.62 1.046q0 0 0 0c1.06-1.06 2.644-1.331 3.851-.658l1.337.747c1.823 1.017 2.038 3.573.436 5.175-.962.962-2.142 1.711-3.445 1.76a11.3 11.3 0 0 1-3.527-.44"
      })
    ], -1)
  ]))]))
}
export default { render: render }